import axios from 'axios';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { Restaurant } from 'types/Restaurant';

export const getRestaurantList = createAsyncThunk(
  'restaurant/getRestaurantList',
  async (params: { lang: string; brand?: number }, thunkAPI) => {
    const { lang, brand } = params;
    try {
      const response = await axios.get<Restaurant[]>(
        `${process.env.REACT_APP_V3}/restaurant/`,
        {
          headers: {
            'Accept-Language': lang,
          },
          params: {
            brand,
          },
        }
      );
      return response.data;
    } catch (e) {
      return thunkAPI.rejectWithValue(
        `Failed to get a list of restaurants with an error ${e}`
      );
    }
  }
);
